import cls from 'classnames';
import { useEffect, useState } from 'react';

import useVideoMediaStyles from './videoMediaStyles';

function VideoMedia({ url }: { url: string }) {
  const classes = useVideoMediaStyles();
  const [content, setContent] = useState(null);

  useEffect(() => {
    url &&
      setTimeout(() => {
        setContent(<object className={classes.video} data={url} />);
      }, 5000);
  }, []);

  return (
    <div className={cls('flex', 'align-center', 'justify-center', classes.videoContainer)}>
      {content}
    </div>
  );
}

export default VideoMedia;
